import React from 'react';

import Button from '../../../../../../shared/components/button';
import { MicrophoneButtonProps } from '../types';
import css from './style.css';
import { useWave } from './use-wave';

export const UnmutedMicrophoneButton: React.FC<MicrophoneButtonProps> = ({
    size,
    onClick,
    title,
    disabled,
    buttonProps,
    testId,
}) => {
    const { canvasRef } = useWave();

    const microphoneIcon = (
        <div className={css.iconContainer}>
            <canvas ref={canvasRef} />
        </div>
    );

    return (
        <Button
            view="neutral"
            size={size}
            onClick={onClick}
            isDisabled={disabled}
            testId={testId}
            icon={microphoneIcon}
            title={title}
            {...buttonProps}
        />
    );
};
